<template>
  <div>
    <n-bread v-bind:content="{ bread_list, bread_active }"></n-bread>
    <div class="row">
      <div class="col">
        <n-trashed></n-trashed>
      </div>
    </div>
  </div>
</template>
<script>
import NTrashed from "@/partials/dashboard/trashed_buildings";
import NBread from "@/partials/bread";
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  data() {
    return {};
  },
  components: {
    NBread,
    NTrashed,
  },
  created() {
    this.lang = window.localStorage.getItem("language");
    if (this.lang === "es") {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Mi basura" },
      });
    } else {
      this.SET_DATA({
        name: "bread_active",
        data: { label: "Il mio Cestino" },
      });
    }
  },
  computed: {
    ...mapState("n_trash", ["bread_active", "bread_list"]),
  },

  methods: {
    ...mapMutations("n_trash", ["SET_DATA"]),
  },
};
</script>